import { useState } from "react";
import PropTypes from "prop-types";
import AttachmentUploader_Modal from "./AttachmentUploader_Modal";
import { Button } from "@mui/material";
import { AddIcon } from "../icons/ActionIcons";

export default function AttachmentUploaderButton({
  buttonText = "LISÄÄ LIITE",
  variant = "contained",
  icon = () => <AddIcon />,
  onUpload = () => {},
  keikkaId = 0,
  buttonProps = {},
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);

  return (
    <>
      <AttachmentUploader_Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onUpload={onUpload}
        keikkaId={keikkaId}
      />
      <Button
        variant={variant}
        onClick={handleOpen}
        startIcon={icon()}
        color="primary"
        {...buttonProps}>
        {buttonText}
      </Button>
    </>
  );
}

AttachmentUploaderButton.propTypes = {
  buttonText: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.func,
  onUpload: PropTypes.func,
  keikkaId: PropTypes.number,
  buttonProps: PropTypes.object,
};
